const SIREN_REGEX = /^\d{9}$/;
const SIRET_REGEX = /^\d{14}$/;
const RNA_REGEX = /^W[0-9A-Z]{9}$/;
export const SIGNATURE_MAX_BYTES = 2 * 1024 * 1024;
export const SIGNATURE_ACCEPTED_MIME = ["image/png", "image/jpeg"];
// Length caps mirror the OPUS UpdateClientLegalInfoCommandValidator so the FE
// rejects (and the inputs hard-cap) before the request reaches the backend.
export const SIGNATORY_NAME_MAX_LENGTH = 200;
export const RECEIPT_OBJECT_MAX_LENGTH = 500;
export const ORGANIZATION_QUALIFICATION_MAX_LENGTH = 500;
export function validateSiren(value) {
    if (!value)
        return null;
    return SIREN_REGEX.test(value) ? null : "workspace.settings.errors.sirenFormat";
}
export function validateSiret(value) {
    if (!value)
        return null;
    return SIRET_REGEX.test(value) ? null : "workspace.settings.errors.siretFormat";
}
export function validateRna(value) {
    if (!value)
        return null;
    return RNA_REGEX.test(value) ? null : "workspace.settings.errors.rnaFormat";
}
export function validateIdentifiersRequired(values) {
    const hasAny = Boolean(values.siren) || Boolean(values.siret) || Boolean(values.rna);
    return hasAny ? null : "workspace.settings.errors.identifierRequired";
}
// The receipt-facing fields are all printed on every tax receipt, so none may be blank while
// receipts are issued (OPUS only caps their length; the requirement is enforced here, and waived by
// `useWorkspaceLegalInfoForm` save({ requireComplete: false })).
export function validateSignatoryFunction(value) {
    return value.trim() ? null : "workspace.settings.errors.signatoryFunctionRequired";
}
export function validateSignatoryName(value) {
    if (!value.trim())
        return "workspace.settings.errors.signatoryNameRequired";
    return value.length <= SIGNATORY_NAME_MAX_LENGTH
        ? null
        : "workspace.settings.errors.signatoryNameTooLong";
}
export function validateReceiptObject(value) {
    if (!value.trim())
        return "workspace.settings.errors.receiptObjectRequired";
    return value.length <= RECEIPT_OBJECT_MAX_LENGTH
        ? null
        : "workspace.settings.errors.receiptObjectTooLong";
}
export function validateOrganizationQualification(value) {
    if (!value.trim())
        return "workspace.settings.errors.organizationQualificationRequired";
    return value.length <= ORGANIZATION_QUALIFICATION_MAX_LENGTH
        ? null
        : "workspace.settings.errors.organizationQualificationTooLong";
}
/** The signature shown on screen: a stored URL or the pending upload's blob URL; null once removed. */
export function validateSignaturePresent(signatureUrl) {
    return signatureUrl ? null : "workspace.settings.errors.signatureRequired";
}
export function validateSignatureFile(file) {
    if (!file)
        return null;
    if (!SIGNATURE_ACCEPTED_MIME.includes(file.type)) {
        return "workspace.settings.errors.signatureFormat";
    }
    if (file.size > SIGNATURE_MAX_BYTES) {
        return "workspace.settings.errors.signatureSize";
    }
    return null;
}
/**
 * The identity fields the workspace page edits. The receipt-facing fields are validated where they
 * are edited (`useWorkspaceLegalInfoForm`).
 */
export function validateWorkspaceIdentity(state) {
    const errors = {};
    const sirenErr = validateSiren(state.siren);
    if (sirenErr)
        errors.siren = sirenErr;
    const siretErr = validateSiret(state.siret);
    if (siretErr)
        errors.siret = siretErr;
    const rnaErr = validateRna(state.rna);
    if (rnaErr)
        errors.rna = rnaErr;
    const identifiersErr = validateIdentifiersRequired(state);
    if (identifiersErr)
        errors.identifiers = identifiersErr;
    return errors;
}
export function hasErrors(errors) {
    return Object.keys(errors).length > 0;
}
